import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { observable } from 'mobx';
import TimeRange from '../utils/TimeRange';
var Consultation = (_class = /*#__PURE__*/function (_Model) {
  function Consultation(attrs, opts) {
    var _this;
    _classCallCheck(this, Consultation);
    _this = _callSuper(this, Consultation, arguments);
    _initializerDefineProperty(_this, "id", _descriptor, _this);
    _initializerDefineProperty(_this, "jobId", _descriptor2, _this);
    _initializerDefineProperty(_this, "status", _descriptor3, _this);
    _initializerDefineProperty(_this, "availability", _descriptor4, _this);
    _initializerDefineProperty(_this, "availabilityCreateTime", _descriptor5, _this);
    _initializerDefineProperty(_this, "clientUserPublicId", _descriptor6, _this);
    _initializerDefineProperty(_this, "providerUserPublicId", _descriptor7, _this);
    _initializerDefineProperty(_this, "createdByUserPublicId", _descriptor8, _this);
    _initializerDefineProperty(_this, "bookedTime", _descriptor9, _this);
    _initializerDefineProperty(_this, "bookingCreateTime", _descriptor10, _this);
    _initializerDefineProperty(_this, "createTime", _descriptor11, _this);
    _initializerDefineProperty(_this, "requestedLength", _descriptor12, _this);
    _initializerDefineProperty(_this, "skipScheduling", _descriptor13, _this);
    _this.rootStore = opts.rootStore;
    return _this;
  }
  _inherits(Consultation, _Model);
  return _createClass(Consultation, [{
    key: "parse",
    value: function parse(json) {
      return {
        id: json.id,
        jobId: json.jobId,
        availability: json.availability ? json.availability.availability_times.map(function (a) {
          return new TimeRange(new Date(a.start_time), new Date(a.end_time));
        }) : undefined,
        availabilityCreateTime: json.availabilityCreateTime ? new Date(json.availabilityCreateTime) : undefined,
        createdByUserPublicId: json.created_by_user_public_id,
        clientUserPublicId: json.client_user_public_id,
        providerUserPublicId: json.provider_user_public_id ? json.provider_user_public_id : undefined,
        bookedTime: json.booked_time ? new TimeRange(new Date(json.booked_time.start_time), new Date(json.booked_time.end_time)) : undefined,
        bookingCreateTime: json.booking_create_time ? new Date(json.booking_create_time) : undefined,
        createTime: json.create_time ? new Date(json.create_time) : undefined,
        requestedLength: json.requested_length,
        skipScheduling: json.skip_scheduling,
        status: json.status,
        room: this.rootStore.roomStore.primeRoom({
          id: json.room_id
        })
      };
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "id", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "jobId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "availability", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return [];
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "availabilityCreateTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "clientUserPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "providerUserPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "createdByUserPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "bookedTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "bookingCreateTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "createTime", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "requestedLength", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "skipScheduling", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Consultation as default };
//# sourceMappingURL=Consultation.js.map
